export default "__VITE_ASSET__DS_Fq8X0__"